/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ordersEndPoints } from 'api/orders/constants';
import {
  TOrdersGetListBE,
  TOrdersGetListQueryParams,
} from 'api/orders/orders.types';
import createHttpClient from 'store/httpClient';
import { fromObjectToQueryString } from 'utils/api';
import { ORDERS_GET_LIST_MOCK } from './orders.mock';

export const getOrdersListAsyncThunk = createAsyncThunk<
  TOrdersGetListBE['data'],
  { queryParams: TOrdersGetListQueryParams } | void
>('orders/getList', async (args, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.get<TOrdersGetListBE>(
      ordersEndPoints.getList(
        fromObjectToQueryString(
          typeof args === 'object' ? args?.queryParams : {}
        )
      )
    );

    return ORDERS_GET_LIST_MOCK;
  } catch (_) {
    return rejectWithValue(null);
  }
});
